import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  divider: {
    height: 1,
    alignSelf: 'center',
  },
  secondSectionLineStyle: {
    marginLeft: 16,
    marginBottom: 22.1,
    marginTop: 27.9,
    height: 12,
  },
  thirdSectionFirstStyle: {
    marginTop: 17.9,
  },
  thirdSectionStyle: {
    marginTop: 36.4,
    paddingLeft: 16,
  },
  thirdSectionCircleStyle: {
    width: 29,
    height: 29,
    borderRadius: 50,
    marginRight: 19,
  },
  thirdSectionLineStyle: {
    height: 12,
    marginBottom: 9,
  },
  thirdSectionSquareStyle: {
    width: 54,
    height: 12,
    marginBottom: 9,
    marginRight: 14,
  },
});
